export default __webpack_public_path__ + "static/media/_IMG2097.5828c0c9.jpg";